import React from 'react';

import { Modal } from 'ui';

import { Content, LeftParagraph } from './modal-privacy-policy.styles';

interface ModalPrivacyPolicyProps {
  show: boolean;
  toggle: () => void;
}

export const ModalPrivacyPolicy = ({
  show,
  toggle,
}: ModalPrivacyPolicyProps) => (
  <Modal show={show} title="Política de Privacidade" close={toggle} size="xl">
    <Content>
      <p>
        Para o <b>EnergyPass</b>, privacidade e segurança são prioridades e nos
        comprometemos com a transparência do tratamento de dados pessoais dos
        nossos Usuários/Clientes. Por isso, a presente Política de Privacidade
        estabelece como é feita a coleta, uso e transferência de informações de
        clientes ou outras pessoas que acessam ou usam nossa plataforma.
      </p>
      <p>
        Ao utilizar nossos serviços, você entende que coletaremos e usaremos
        suas informações pessoais nas formas descritas nesta Política, sob as
        normas da Lei Geral de Proteção de Dados (LGPD, Lei Federal
        13.709/2018), das disposições consumeristas (da Lei Federal 8078/1990) e
        as demais normas do ordenamento jurídico brasileiro aplicáveis.
      </p>
      <p>
        Dessa forma, a <b>ENERGY PASS CONSULTORIA E GESTAO DE ENERGIA LTDA</b>,
        doravante denominado simplesmente como “<b>EnergyPass</b>” inscrita no
        CNPJ/MF sob o n° 49.076.630/0001- 39, com sede na Rua Uirapuru, n° 615 –
        Letra B, Jardim São Gonçalo, Campinas/SP, no papel de Controladora de
        Dados, obriga-se ao disposto na presente Política de Privacidade.
      </p>
      <h3>1. Definições básicas para fins da LGPD</h3>
      <p>
        Os termos aqui constantes em maiúsculo contém as definições detalhadas
        ao longo do texto.
      </p>
      <p>
        <u>Titular do dado pessoal</u>: é a pessoa natural a quem se referem os
        dados pessoais que são objeto de tratamento.
      </p>
      <p>
        <u>Dado pessoal</u>: informação relacionada a uma pessoa natural
        identificada ou identificável. Isso quer dizer que dado pessoal pode ser
        desde uma informação relacionada ao nome do Titular, sua idade e
        informação básica de sua identificação, como sua nacionalidade, local de
        nascimento, R.G., C.P.F. ou endereço de residência, bem como informações
        financeiras, incluindo números de contas bancárias, números de cartões
        de crédito, hábitos de consumo, perfil comportamental, aparência,
        aspectos da personalidade, entre outros.
      </p>
      <p>
        <u>Dados pessoais sensíveis</u>: Dados pessoais sensíveis são aqueles em
        que a LGPD conferiu uma proteção ainda maior, por tratarem de aspectos
        mais íntimos do Titular. Assim, são dados pessoais sensíveis aqueles
        relativos à origem racial ou étnica do Titular, convicção religiosa,
        opinião política, filiação a sindicato ou a organização de caráter
        religioso, filosófico ou político, dados referentes à saúde ou à vida
        sexual e dados genéticos ou biométricos.{' '}
        <b>
          O EnergyPass, como regra geral, não realiza o tratamento de dados
          pessoais sensíveis
        </b>
        .
      </p>
      <p>
        <u>Tratamento de dados pessoais</u>: é toda operação realizada com dados
        pessoais, como as que se referem à coleta, produção, recepção,
        classificação, utilização, acesso, reprodução, transmissão,
        distribuição, processamento, arquivamento, armazenamento, eliminação,
        avaliação ou controle da informação, modificação, comunicação,
        transferência, difusão ou extração (“Tratamento”).
      </p>
      <p>
        <u>Consentimento</u>: é a manifestação livre, informada e inequívoca
        pela qual o Titular concorda com o tratamento de seus dados pessoais
        para uma finalidade determinada.
      </p>
      <p>
        <u>Controlador</u>: é a pessoa natural ou jurídica, de direito público
        ou privado, a quem compete as decisões referentes ao tratamento de dados
        pessoais (“Controlador”).
      </p>
      <p>
        <u>Operador</u>: é a pessoa natural ou jurídica, de direito público ou
        privado, que realiza o tratamento de dados pessoais em nome do
        controlador (“Operador”).
      </p>
      <p>
        <u>Suboperador</u>: é a pessoa natural ou jurídica contratada pelo
        operador para auxiliá-lo a realizar o tratamento de dados pessoais em
        nome do controlador (“Suboperador”).
      </p>
      <p>
        <u>Encarregado</u>: é a pessoa natural ou jurídica (“Encarregado”)
        indicada pelo controlador e operador para atuar como canal de
        comunicação entre o controlador, os titulares dos dados e a Autoridade
        Nacional de Proteção de Dados (“ANPD”).
      </p>
      <h3>2. Quais dados coletamos sobre você e para qual finalidade?</h3>
      <p>
        Nossa Plataforma coleta e utiliza alguns dados pessoais seus, de forma a
        viabilizar a prestação de serviços e aprimorar a experiência de uso.
      </p>
      <h3>2.1. Dados pessoais fornecidos pelo titular</h3>
      <ul>
        <li>
          <i>
            Pessoas físicas: nome completo, data de nascimento, endereço, CPF,
            e-mail, telefone, (finalidade: dados para cadastro).
          </i>
        </li>
        <li>
          <i>
            Pessoas jurídicas: razão social, endereço, CNPJ, inscrição estadual,
            e-mail, telefone (finalidade: dados para cadastro).
          </i>
        </li>
      </ul>
      <p>
        Além dos dados pessoais, são coletados dados para cadastro das Unidades
        Consumidoras tais quais: número da unidade consumidora, classificação
        tarifária, consumo e gastos com energia elétrica, login e senha dos
        sistemas de monitoramento do(s) inversor(es) disponibilizados pelo
        titular através de documentos e/ou informações anexadas na plataforma
        (finalidade: viabilização da prestação de serviços).
      </p>
      <p>
        Também poderão ser coletados e tratados logins e senhas da conta de
        acesso da distribuidora de energia e, de eventual sistema fotovoltaico,
        vinculado ao titular, de modo a integralizar e complementar todos os
        dados disponíveis nos referidos sistemas (finalidade: viabilização da
        prestação de serviços).
      </p>
      <h3>2.2. Dados pessoais coletados automaticamente</h3>

      <ul>
        <li>
          <i>Dados de navegação durante permanência na plataforma.</i>
        </li>
        <li>
          <i>
            Informações de geração de energia coletadas através das API dos
            fabricantes dos inversores.
          </i>
        </li>
      </ul>

      <h3>3. Como coletamos os seus dados?</h3>
      <p>
        Nesse sentido, a primeira coleta de dados pessoais ocorre com o cadastro
        do Usuário para Conta de Acesso. Os dados são armazenados no banco de
        dados PostgreSQL da plataforma e enviados através servidor da Locaweb.
      </p>
      <p>
        Posteriormente, as coletas ocorrem a partir do preenchimento pelo
        usuário dos campos destinados a inserção de documentos para a
        operacionalização dos serviços disponibilizados na plataforma.
      </p>
      <p>
        A depender dos serviços a serem contratados (através de Planos
        Adicionais) poderão ser solicitados novos dados, os quais serão
        utilizados meramente para os fins da contratação.
      </p>

      <h3>3.1. Consentimento</h3>

      <p>
        <b>
          É a partir do seu consentimento que tratamos os seus dados pessoais. O
          consentimento é a manifestação livre, informada e inequívoca pela qual
          você autoriza o EnergyPass a tratar seus dados.
        </b>
      </p>
      <p>
        <b>
          Assim, em consonância com a Lei Geral de Proteção de Dados, seus dados
          só serão coletados, tratados e armazenados mediante prévio e expresso
          consentimento.
        </b>
      </p>

      <p>
        <b>
          O seu consentimento será obtido de forma específica para cada
          finalidade acima descrita, evidenciando o compromisso de transparência
          e boa-fé do EnergyPass para com seus Usuários/Clientes, seguindo as
          regulações legislativas pertinentes.
        </b>
      </p>

      <p>
        <b>
          Ao utilizar os serviços do EnergyPass e fornecer seus dados pessoais,
          você está ciente e consentindo com as disposições desta Política de
          Privacidade, além de conhecer seus direitos e como exercê-los.
        </b>
      </p>

      <p>
        <b>
          A qualquer tempo e sem nenhum custo, você poderá revogar seu
          consentimento.
        </b>
      </p>

      <p>
        <b>
          É importante destacar que a revogação do consentimento para o
          tratamento dos dados pode implicar a impossibilidade da performance
          adequada de alguma funcionalidade do site que dependa da operação.
          Tais consequências serão informadas previamente.
        </b>
      </p>

      <h3>4. Quais são os seus direitos?</h3>

      <p>
        O <b>EnergyPass</b> assegura a seus Usuários/Clientes seus direitos de
        titular previstos no artigo 18° da Lei Geral de Proteção de Dados. Dessa
        forma, você pode, de maneira gratuita e a qualquer tempo:
      </p>
      <ul>
        <li>
          <b>Confirmar a existência de tratamento de dados</b>, de maneira
          simplificada ou em formato claro e completo.
        </li>
        <li>
          <b>Acessar seus dados</b>, podendo solicitá-los em uma cópia legível
          sob forma impressa ou por meio eletrônico, seguro e idôneo.
        </li>
        <li>
          <b>Corrigir seus dados</b>, ao solicitar a edição, correção ou
          atualização destes.
        </li>
        <li>
          <b>Limitar seus dados</b> quando desnecessários, excessivos ou
          tratados em desconformidade com a legislação através da anonimização,
          bloqueio ou eliminação.
        </li>
        <li>
          <b>Solicitar a portabilidade de seus dados</b>, através de um
          relatório de dados cadastrais que o <b>EnergyPass</b> trata a seu
          respeito.
        </li>
        <li>
          <b>Eliminar seus dados</b> tratados a partir de seu consentimento,
          exceto nos casos previstos em lei.
        </li>
        <li>
          <b>Revogar seu consentimento</b>, desautorizando o tratamento de seus
          dados.
        </li>
        <li>
          <b>
            Informar-se sobre a possibilidade de não fornecer seu consentimento
          </b>{' '}
          e sobre as consequências da negativa.
        </li>
      </ul>

      <h3>5. Como você pode exercer seus direitos de titular?</h3>

      <p>
        Para exercer seus direitos de titular, você deve entrar em contato com o{' '}
        <b>EnergyPass</b> através dos seguintes meios disponíveis:
      </p>

      <p>
        (a) Através do e-mail: <b>energypass@solsticioenergia.com</b> sempre
        acompanhada das informações de contato do Usuário, tal como nome
        completo, CPF e e-mail cadastrado, para que possamos prosseguir
        adequadamente com o atendimento.
      </p>
      <p>
        (b) Através do Serviço de Atendimento pelo WhatsApp{' '}
        <b>(19) 97108-1263</b>.
      </p>
      <p>
        De forma a garantir a sua correta identificação como titular dos dados
        pessoais objeto da solicitação, é possível que solicitemos documentos ou
        demais comprovações que possam comprovar sua identidade. Nessa hipótese,
        você será informado previamente.
      </p>

      <h3>6. Como e por quanto tempo seus dados serão armazenados?</h3>

      <p>
        Seus dados pessoais coletados pelo <b>EnergyPass</b> e serão utilizados
        e armazenados durante o tempo necessário para a prestação do serviço ou
        para que as finalidades elencadas na presente Política de Privacidade
        sejam atingidas, considerando os direitos dos titulares dos dados e dos
        controladores.
      </p>
      <p>
        De modo geral, seus dados serão mantidos enquanto a relação contratual
        entre você e o <b>EnergyPass</b> perdurar. Findado o período de
        armazenamento dos dados pessoais, estes serão excluídos automaticamente
        após o período de 5 (cinco) anos a partir do desligamento do usuário de
        nossas bases de dados ou anonimizados, ressalvadas as hipóteses
        legalmente previstas no artigo 16° da Lei Geral de Proteção de Dados, a
        saber:
      </p>
      <LeftParagraph>
        <p>
          I – Cumprimento de obrigação legal ou regulatória pelo controlador;
        </p>
        <p>
          II – Estudo por órgão de pesquisa, garantida, sempre que possível, a
          anonimização dos dados pessoais;
        </p>
        <p>
          III – Transferência a terceiro, desde que respeitados os requisitos de
          tratamento de dados dispostos nesta Lei; ou
        </p>
        <p>
          IV – Uso exclusivo do controlador, vedado seu acesso por terceiro, e
          desde que anonimizados os dados.
        </p>
      </LeftParagraph>
      <p>
        Isto é, informações pessoais sobre você que sejam imprescindíveis para o
        cumprimento de determinações legais, judiciais e administrativas e/ou
        para o exercício do direito de defesa em processos judiciais e
        administrativos serão mantidas, a despeito da exclusão dos demais dados.
      </p>

      <p>
        O armazenamento de dados coletados pelo <b>EnergyPass</b> reflete o
        nosso compromisso com a segurança e privacidade dos seus dados.
        Empregamos medidas e soluções técnicas de proteção aptas a garantir a
        confidencialidade, integridade e inviolabilidade dos seus dados. Além
        disso, também contamos com medidas de segurança apropriadas aos riscos e
        com controle de acesso às informações armazenadas.
      </p>

      <h3>7. O que fazemos para manter seus dados seguros?</h3>

      <p>
        Para mantermos suas informações pessoais seguras, usamos ferramentas
        físicas, eletrônicas e gerenciais orientadas para a proteção da sua
        privacidade.
      </p>

      <p>
        Aplicamos essas ferramentas levando em consideração a natureza dos dados
        pessoais coletados, o contexto e a finalidade do tratamento e os riscos
        que eventuais violações gerariam para os direitos e liberdades do
        titular dos dados coletados e tratados. Entre as medidas que adotamos,
        destacamos as seguintes:
      </p>

      <ul>
        <li>
          Apenas pessoas autorizadas têm acesso a seus dados pessoais, isto é,
          colaboradores do EnergyPass ou de seu grupo econômico, e o próprio
          titular (Usuário da Plataforma).
        </li>
        <li>
          O acesso a seus dados pessoais é feito somente após o compromisso de
          confidencialidade.
        </li>
        <li>
          Seus dados pessoais são armazenados em ambiente seguro e idôneo
          através de criptografia.
        </li>
      </ul>

      <p>
        O <b>EnergyPass</b> se compromete a adotar as melhores posturas para
        evitar incidentes de segurança.
      </p>
      <p>
        Em caso de incidentes de segurança que possa gerar risco ou dano
        relevante para você ou qualquer um de nossos Usuários/Clientes,
        comunicaremos aos afetados e a Autoridade Nacional de Proteção de Dados
        sobre o ocorrido, em consonância com as disposições da Lei Geral de
        Proteção de Dados.
      </p>

      <h3>8. Com quem seus dados podem ser compartilhados?</h3>

      <p>
        Tendo em vista a preservação de sua privacidade, o <b>EnergyPass</b> não
        compartilhará seus dados pessoais com nenhum terceiro não autorizado.
      </p>

      <p>
        Existem hipóteses em que seus dados poderão ser compartilhados, que são:
      </p>

      <p>
        I – Determinação legal, requerimento, requisição ou ordem judicial, com
        autoridades judiciais, administrativas ou governamentais competentes.
      </p>

      <p>
        II – Caso de movimentações societárias, como fusão, aquisição e
        incorporação, de forma automática.
      </p>
      <p>
        III – Proteção dos direitos do <b>EnergyPass</b> em qualquer tipo de
        conflito, inclusive os de teor judicial.
      </p>

      <h3>9. Proteção de Dados Pessoais de Crianças e Adolescentes</h3>

      <p>
        Os serviços prestados pelo <b>EnergyPass</b> não são destinados a
        menores de 18 (dezoito) anos de idade. Por esse motivo, o{' '}
        <b>EnergyPass</b>, como regra geral,{' '}
        <b>
          não realiza o tratamento de dados pessoais de menores de 18 (dezoito)
          anos
        </b>
        .
      </p>

      <p>
        Excepcionalmente, poderemos realizar o tratamento de dados de crianças
        ou adolescentes diretamente ou na qualidade de Operadora ou Suboperadora
        de nossos Usuários/Clientes.
      </p>

      <p>
        Em tais casos, nós observaremos estritamente as regras constantes da
        LGPD, assim como demandaremos o seu cumprimento por nossos
        Usuários/Clientes. Somente deverão ser tratados dados de menores de 18
        (dezoito) anos quando devidamente anonimizados ou para atender ao seu
        melhor interesse, com o consentimento específico e em destaque dado por
        pelo menos um dos pais ou pelo responsável legal, observadas as demais
        previsões constantes da LGPD.
      </p>

      <h3>10. Alteração desta Política de Privacidade</h3>

      <p>
        Reservamos o direito de modificar essa Política de Privacidade a
        qualquer tempo, principalmente em função da adequação a eventuais
        alterações feitas em nosso Site, Aplicativo ou em âmbito legislativo.
        Portanto, recomendamos que você revise com frequência a presente
        Política.
      </p>

      <p>
        Eventuais alterações entrarão em vigor a partir de sua publicação em
        nosso Site ou Aplicativo e sempre lhe notificaremos acerca das mudanças
        ocorridas.
      </p>

      <p>
        Ao utilizar nossos serviços e fornecer seus dados pessoais após tais
        modificações, você as consente.
      </p>

      <h3>11. Encarregado de Proteção de Dados</h3>

      <p>
        Cumpre ressaltarmos que, diante da Resolução CD/ANPD no 2, de 27 de
        janeiro de 2022, a empresa neste ato representada não precisaria nomear
        um Encarregado, ou, em outras palavras, um DPO (Data Protection
        Officer), segue dispositivo que habilita esta ação: <b>Art. 11</b>. Os
        agentes de tratamento de pequeno porte não são obrigados a indicar o
        encarregado pelo tratamento de dados pessoais exigido no art. 41 da
        LGPD.
      </p>

      <p>
        Muito embora não precise de um Encarregado, aponta norma proposta que:{' '}
        <b>§ 1º</b>- O agente de tratamento de pequeno porte que{' '}
        <u>
          não indicar um encarregado deve disponibilizar um canal de comunicação
          com o titular de dados para atender o disposto no art. 41
        </u>
        , § 2o, I da LGPD.
      </p>

      <p>
        Por este motivo, o <b>EnergyPass</b> disponibiliza dois canais de
        comunicação, através dos contatos disponibilizados no item 5 da presente
        Política, para que você possa entrar em contato conosco para exercer
        seus direitos de titular ou caso tenha dúvidas sobre esta Política de
        Privacidade ou sobre os dados pessoais que tratamos.
      </p>
    </Content>
  </Modal>
);
